import { Image } from 'antd';
import Page from '../../components/page';
import ActionHeader from '../../components/actionHeader';
import { useNavigate } from 'react-router';

const Flow = () => {
  const navigate = useNavigate();

  return (
    <Page
      header={
        <ActionHeader
          title="Flow (Coming soon)"
          showBack
          onBack={() => navigate(-1)}
        />
      }
    >
      <Image src="/flow.png" preview={false} style={{ width: '100%' }} />
    </Page>
  );
};

export default Flow;
